import { parseFormattedDateString } from './date.helpers';
import { i18n } from '@/i18n';

export function yupTransformDate(value, originalValue) {
    return parseFormattedDateString(originalValue);
}

/**
 * Rejects a value that starts or ends with whitespace. The backend trims these fields on save,
 * so without this rule the value the user typed differs from the value that gets stored.
 *
 * Usage: string().required(...).test(noSurroundingSpaces(t('entity.detail.label')))
 */
export function noSurroundingSpaces(fieldName: string) {
    return {
        name: 'no-surrounding-spaces',
        message: i18n.global.t('validations.messages.noSurroundingSpaces', { _field_: fieldName }),
        test: (value?: string) => value === undefined || value === null || value === value.trim(),
    };
}
